(function Module() {
	'use strict';

	mySynch.controller('FertilityCodesProgramsController', [
		'$scope',
		'$timeout',
		'MySynchFactory',
		'ApiFactory',
		'ViewAuthorizationFactory',
		'mySynchEnumerationService',
		'performanceMetricsService',
		'performanceContextService',
		'$q',
		'clientLoggerService',
		function FertilityCodesProgramsController($s, $timeout, MSF, api, viewAuth,mySynchEnumSvc, perfMetricSvc, perfContextSvc, $q, log) {
			var self = this;

			$s.canUpdate = false;

			// deregistration functions
			var deregOnPermissionChanged = null;
			var deregOnHerdChanged = null;

			$s.performanceContext = null;

			$s.hasPermission = function hasPermission(permission) {
				return viewAuth.hasPermission(mySynchEnumSvc.getMySynchEnumerationName("Permission",permission));
			};

			deregOnPermissionChanged = $s.$on('permission:changed', function onPermissionChanged() {
				checkPermissions();
			});

			function checkPermissions() {
				$s.canUpdate = viewAuth.hasPermission(mySynchEnumSvc.getMySynchEnumeration('Permission','COMMON_SETTINGS_UPDATE'));

				if (!$s.hasPermission('COMMON_SETTINGS_READ')) {
					MSF.loadPage('Login');

					return false;
				}

				return true;
			}

			function addDisplayedDates(program) {
				program.displayedProgramStartDate = program.programStartDate ?
					new Date(moment(program.programStartDate).subtract(moment(program.programStartDate).utcOffset(), 'minutes').format()) : null;
				program.displayedProgramEndDate = program.programEndDate ?
					new Date(moment(program.programEndDate).subtract(moment(program.programEndDate).utcOffset(), 'minutes').format()) : null;

				return program;
			}

			function addDisplayedDatesToPrograms(programs) {
				return _.map(programs, addDisplayedDates);
			}

			//	$scope properties
			$s.fcpExports = {isNewProgram: false};

			//	controller properties
			self.loading = true;
			self.fertilityPrograms = [];

			//	$scope methods
			$s.loadFertilityPrograms = function loadFertilityPrograms(callback) {
				if ($s.fcpExports.isNewProgram) {
					return false;
				}

				self.loading = true;

				perfMetricSvc.startTiming('Page:FertilityProgramsPageData:Request');
				api.getHerdFertilityProgramsByHerdId(MSF.getActiveHerd().herdId, $s.performanceContext, function programsGotten(err, programs) {
					perfMetricSvc.endTiming("page",'Page:FertilityProgramsPageData:Request', $s.performanceContext);
					self.loading = false;

					if (err) {
						log.error({error: err}, 'Error getting ferility programs by herdId');

						return MSF.notify.danger('Unable to load programs');
					}

					perfMetricSvc.startTiming('Page:FertilityPrograms:Build');
					if (_.isEmpty(programs)) {
						// treat as if [add new program] has been clicked
						$s.fcpExports.isNewProgram = true;
						MSF.setActiveHerdFertilityProgram({
							herdFertilityProgramId: 'new',
							programStartDate: new Date(moment().subtract(12, 'months').format()),
							programEndDate: null
						});
						perfMetricSvc.endTiming("page",'Page:FertilityPrograms:Build', $s.performanceContext);
						return;
					}

					self.fertilityPrograms = addDisplayedDatesToPrograms(_.sortBy(programs, function eachProgram(program) {
						return +moment(program.programEndDate);
					}).reverse());

					MSF.setActiveHerdFertilityProgram(programs[0]);
					var requestedProgramId = _.get(MSF, 'state.params.program');

					if (requestedProgramId) {
						var requestedProgram = _.find(programs, {herdFertilityProgramId: requestedProgramId});

						if (requestedProgram) {
							MSF.setActiveHerdFertilityProgram(requestedProgram);
						}
					}

					if (_.isFunction(callback)) {
						perfMetricSvc.endTiming("page",'Page:FertilityPrograms:Build', $s.performanceContext);
						callback(programs);
					} else {
						perfMetricSvc.endTiming("page",'Page:FertilityPrograms:Build', $s.performanceContext);
					}
				});
			};

			$s.chooseFertilityProgram = function chooseFertilityProgram(program) {
				$s.fcpExports.isNewProgram = false;
				MSF.setActiveHerdFertilityProgram(program);
			};

			//	controller methods
			self.addNewProgram = function addNewProgram() {
				$s.tabsetCtrl.selectTab(_.find($s.tabsetCtrl.tabs, function findCommonSettingsTab(tab) {
					return _.includes(tab.templateUrl, 'basic.view');
				}));

				$timeout(function timeoutToAvoidScopeApplyIfDigestIsInProgress() {
					$s.fcpExports.isNewProgram = true;
					var newFertilityProgram = _.extend(_.cloneDeep(MSF.getActiveHerdFertilityProgram()), {
						herdFertilityProgramId: 'new',
						programStartDate: new Date(moment().subtract(12, 'months').format()),
						programEndDate: null
					});

					MSF.setActiveHerdFertilityProgram(addDisplayedDates(newFertilityProgram));
				});
			};

			self.deleteProgram = function deleteProgram() {
				var fertilityProgramStartDate = moment(MSF.getActiveHerdFertilityProgram().programStartDate).format(MSF.i18n.format.dateLong);
				var fertilityProgramEndDate = moment(MSF.getActiveHerdFertilityProgram().programEndDate).format(MSF.i18n.format.dateLong);

				MSF.confirm({
					title: 'Delete Fertility Program',
					message: 'Are you sure you want to delete the fertility program from ' + fertilityProgramStartDate + ' to ' + fertilityProgramEndDate + '?',
					confirm: {
						className: 'danger',
						icon: 'trash'
					}
				}, function confirmCallback() {
					self.loading = true;

					api.deleteHerdFertilityProgram(MSF.getActiveHerdFertilityProgram().herdFertilityProgramId, function herdFertilityProgramDeleted(err, result) {
						self.loading = false;

						if (err) {
							var errorMessage = 'Error deleting herd fertility program!';

							log.error({error: err}, errorMessage);

							return MSF.notify.danger(errorMessage);
						}

						$s.loadFertilityPrograms(function successfulDeleteMessage() {
							MSF.notify.success('Herd Fertility Program Deleted successfully');
						});
					});
				}, function cancelCallback() {
					return log.debug('Cancelled!');
				});
			};

			
			self.endDateToDisplay = function endDateToDisplay(programEndDate) {
				//var formattedEndDate = moment(programEndDate).format('MMMM D, YYYY');
				var formattedEndDate = MSF.getFormattedLongDateString(programEndDate);

				return _.isNull(programEndDate) || moment('9999-12-31').isSame(moment(programEndDate)) ? 'Current' : formattedEndDate;
			};

			deregOnHerdChanged = $s.$on('herd:changed', function herdChanged() {
				if (checkPermissions()) {
					$s.fcpExports.isNewProgram = false;
					perfMetricSvc.startTiming('Page:FertilityProgramsOnHerdChanged:Render');
					$s.loadFertilityPrograms((programs) => {
						perfMetricSvc.markPageReady('Page:FertilityProgramsOnHerdChanged:Render');
					});
				}
			});

			$s.$on('$destroy', function onDestroy() {
				if (deregOnPermissionChanged) {
					deregOnPermissionChanged();
				}

				if (deregOnHerdChanged) {
					deregOnHerdChanged();
				}
				$s.performanceContext = null;
			});

			MSF.ready(function onReady() {
				if (checkPermissions()) {
					$s.performanceContext = perfContextSvc.createPerformanceContext(_.get(MSF.getActiveHerd(),'herdId', null));
					perfMetricSvc.startTiming('Page:FertilityPrograms:Render');
					$s.loadFertilityPrograms((programs) => {
						perfMetricSvc.markPageReady('Page:FertilityPrograms:Render', $s.performanceContext);
					});
				}
			});
		}
	]);
})();
